<script>
export default {
    name: 'ConfirmationModal',
    props: {
        data: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        close() {
            this.$emit('close')
        },
    },
}
</script>

<template>
    <div>
        <h2>Confirm</h2>
        <p>{{ data.message || 'Are you sure?' }}</p>
        <button @click="close">Cancel</button>
        <button @click="close">Confirm</button>
    </div>
</template>